import React, { useMemo, useEffect, useState } from "react";
import styles from "./Paginated.module.scss";
import FundIcon from "../../../assets/images/funded.svg";
import {
	useTable,
	useSortBy,
	useFilters,
	usePagination,
	useGlobalFilter,
	useAsyncDebounce,
	useRowSelect,
	// Column,
} from "react-table";
import { ReactComponent as RightArrow } from "../../assets/images/U_next.svg";
import { ReactComponent as LeftArrowFaded } from "../../assets/images/U_previous.svg";
import ReactPaginate from "react-paginate";
// import { ReactComponent as EmptyTable } from "../../assets/images/empty-table.svg";

type DataColumn = {
	data: any;
	columns: any;
	emptyPlaceHolder: string;
	recent: boolean;
	value?: string;
	clickAction?: boolean;
	total?: string | number | undefined;
	setPageNumber?: any;
	pageNumber?: any;
	nextPage?: number | null;
	previousPage?: number | null;
	setPreviousPage?: React.Dispatch<React.SetStateAction<number | null>>;
	setNextPage?: React.Dispatch<React.SetStateAction<number | null>>;
	rowsPerPage?: number;
	totalPage?: number;
	setRowsPerPage?: React.Dispatch<React.SetStateAction<number>>;
	setContentAction?: any;
	setBearer: any;
};

const initialState = { hiddenColumns: ["id"] };

const PaginationTable = ({
	data,
	columns,
	emptyPlaceHolder,
	recent,
	value,
	clickAction = false,
	total,
	setPageNumber,
	setBearer,
	pageNumber,
	rowsPerPage,
	nextPage,
	previousPage,
	setPreviousPage,
	setNextPage,
	totalPage,
	setRowsPerPage,
	setContentAction,
}: // clickAction,
Partial<DataColumn>) => {
	const {
		getTableProps,
		getTableBodyProps,
		headerGroups,
		page,
		canNextPage,
		canPreviousPage,
		pageOptions,
		pageCount,
		setPageSize,
		state: { pageIndex, pageSize, globalFilter },
		setGlobalFilter,
		prepareRow,
	} = useTable(
		{
			columns,
			data,
			initialState: {
				sortBy: [
					{
						id: "columnId",
						desc: false,
					},
				],
				pageSize: rowsPerPage,
			},
		},
		useFilters,
		useGlobalFilter,
		useSortBy,
		usePagination,
		useRowSelect
	);

	const [searchVal, setSearchVal] = useState(globalFilter);

	const onChangeSearch = useAsyncDebounce((value) => {
		setGlobalFilter(value || undefined);
	}, 1000);

	useEffect(() => {
		setGlobalFilter(value);
		// console.log("Value", value);
	}, [value]);

	const paginate = (value: any) => {
		if (totalPage) {
			if (value > totalPage) {
				return;
			}
		}
		setPageNumber(value);
		setBearer(true);
	};

	return (
		<div className={styles.tableWrapper}>
			<div className={styles.tableBox}>
				<table
					{...getTableProps()}
					style={{ width: "100%", fontFamily: "Avenir" }}
					className={styles.table}
					cellSpacing={0}
				>
					<thead>
						{headerGroups.map((headerGroup) => (
							<tr
								{...headerGroup.getHeaderGroupProps()}
								style={{
									backgroundColor: "#F5F5F5",
									borderRadius: "20px 20px 0px 0px",
									fontFamily: "Avenir",
								}}
							>
								{headerGroup.headers.map((column) => (
									<th
										{...column.getHeaderProps(column.getSortByToggleProps())}
										className={styles.tableHead}
									>
										{column.render("Header")}
										<span>
											{column.isSorted
												? column.isSortedDesc
													? " 🔽"
													: " 🔼"
												: ""}
										</span>
									</th>
								))}
							</tr>
						))}
					</thead>
					<tbody {...getTableBodyProps()} style={{ width: "100%" }}>
						{page?.map((row) => {
							prepareRow(row);
							return (
								<tr
									{...row.getRowProps()}
									className={
										clickAction ? styles.tableBodyHover : styles.tableBody
									}
									onClick={
										clickAction
											? () => setContentAction(row.original)
											: () => null
									}
								>
									{row.cells.map((cell) => {
										return (
											<td
												{...cell.getCellProps()}
												style={{
													padding: "20px",
													fontFamily: "Avenir",
													fontStyle: "normal",
													fontWeight: 400,
													fontSize: "14px",
													lineHeight: "24px",
													letterSpacing: "-0.011em",
													whiteSpace: "nowrap",
													color: "#424242",
													borderBottom: "2px solid #EFF3F8",
													textTransform: "capitalize",
												}}
											>
												{cell.render("Cell")}
											</td>
										);
									})}
								</tr>
							);
						})}
					</tbody>
				</table>
			</div>
			{data.length === 0 && (
				<div className={styles.emptyState}>
					<div className={styles.noTransaction}>{emptyPlaceHolder}</div>
					{/* <EmptyTable /> */}
				</div>
			)}

			{!recent ? (
				<>
					<ReactPaginate
						breakLabel="...."
						nextLabel={
							pageNumber === totalPage ? (
								<div>
									<div
										style={{
											paddingLeft: "40px",
											cursor: "not-allowed",
											pointerEvents: "none",
										}}
									>
										<span className={styles.nextFalse}>Next</span>
										<LeftArrowFaded
											style={{
												transform: "rotate(180deg)",
												cursor: "pointer",
											}}
										/>
									</div>
								</div>
							) : (
								<div onClick={() => paginate(pageNumber + 1)}>
									<div style={{ cursor: "pointer" }}>
										<span className={styles.next}>Next</span>
										<RightArrow />
									</div>
								</div>
							)
						}
						onPageChange={({ selected }) => {
							paginate(selected + 1);
						}}
						pageRangeDisplayed={5}
						pageCount={totalPage ? totalPage : 0}
						previousLabel={
							pageNumber === 1 ? (
								<div style={{ cursor: "not-allowed" }}>
									<LeftArrowFaded />
									<span className={styles.previous}>Prev</span>
								</div>
							) : (
								<div style={{ cursor: "pointer" }}>
									<RightArrow
										style={{
											transform: "rotate(180deg)",
											cursor: "pointer",
										}}
									/>
									<span className={styles.previousTrue}>Prev</span>
								</div>
							)
						}
						renderOnZeroPageCount={null}
						containerClassName={styles.paginatedSection}
						pageClassName={styles.pageLi}
						activeClassName={styles.activePage}
						breakClassName={styles.paginationBreak}
						nextClassName={styles.paginationCtrl}
						previousClassName={styles.paginationCtrl}
					/>
				</>
			) : null}
		</div>
	);
};

export default PaginationTable;
